import * as React from "react"
import { useEffect } from "react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, PRICING_ROUTES, PRODUCT_PAGE_ROUTES} from "@constants"
import { useAppDefaultFilters, useUserApp } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { marketAnalyzerIsEmpty } from "./@signals"


export default function PricingMarketAnalyzerFilters() {
	const { mainSite, userRole } = useUserApp()
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRICING_ROUTES.MARKET_ANALYZER_ID, PRICING_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	const siteProps = userRole === 'retailerUser' ? { excludeOptions: mainSite } : {}

	return <Box data-tour="market-analyzer-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			skuGroup: true, productsInStock: true,
			withShippingPrice: true
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE,
					COMMON_FILTER_KEYS.PRODUCTS_IN_STOCK
				],
				dashboardKey: PRICING_ROUTES.MARKET_ANALYZER_ID
			},
			productsInStock: { grid: { md: 2, xs: 2 } },
			withShippingPrice: { grid: { md: 6, xs: 6 }},
			sku: { grid: { xs: 12, md: 6 }, limitTags: 2 },
            splitKpi: { 
				grid: { xs: 12, md: 6 },
				multiple: false,
				isClearable: false
			},
			site: siteProps
		}}
		onSubmit={() => {
			marketAnalyzerIsEmpty.value = false
			isLoadingCommonFilters.value = true
			isSystemBusy.value = false
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}